import { isStatus } from '@/utils'
import { STATEMENT_STATUSES } from '../constants'
import type { StatementSegment, StatementStatusKey } from '../stores'

export const SET_ASIDE_KIND = 'not_a_statement'

export const isSetAsideKind = (kind: string | null | undefined) =>
  kind?.toLowerCase() === SET_ASIDE_KIND

export const isSetAsideSegment = (segment: StatementSegment) =>
  isSetAsideKind(segment.kind)

export const isStatementSegmentStatus = (
  segment: StatementSegment,
  ...expectations: StatementStatusKey[]
) => isStatus(STATEMENT_STATUSES, segment, 'status', ...expectations)

export const hasStatementSegmentFailed = (segment: StatementSegment) =>
  isStatementSegmentStatus(segment, 'failed')
